module.exports = __webpack_public_path__ + "img/js.43c81454.png";